export const VENDER_AD_WARNING_TEXT =
  '本網頁/APP廣告頁僅提供廠商預約相關服務刊登廣告，相關廣告文宣及其商品或服務均由廠商自行提供，與信義房屋/信義居家無涉，信義房屋/信義居家無法擔保廠商廣告內容的正確性、可信度或即時性，亦不為其商品、服務品質負責，所生任何爭議皆請自行與廠商協調解決。'
